import deepMapKeys from 'deep-map-keys';
import { snakeCase } from 'lodash';

import axios from '../../lib/axios';

export default {
  fetchExercises({ commit }, filters) {
    return axios.get('exercises', { params: { ...deepMapKeys(filters, snakeCase) } }).then(res => {
      commit('setExercises', res.data);
      return Promise.resolve();
    });
  },

  fetchCategories({ commit }) {
    return axios.get('exercises/categories').then(res => {
      commit(
        'setCategories',
        res.data.map(item => ({
          text: item.name,
          value: item.id,
        })),
      );
      return Promise.resolve();
    });
  },

  deleteExercise({ commit }, id) {
    return axios.delete(`exercises/${id}`).then(() => {
      commit('deleteExercise', id);
      return Promise.resolve();
    });
  },

  getTopTags({ commit }, route) {
    return axios.get(`me/top-tags/${route}`).then(response => {
      commit('getTopTags', response.data);

      return Promise.resolve();
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/exercises/actions.js